// 试题类型列表
const questionTypeList = { "MULTI_CHOICE": 0, "SINGLE_CHOICE": 1, "SUBJECTIVE": 2, "NOT_QUESTION": 3 }
// 考试类型列表
const examTypeList = { "ENTRANCE": "入学测试", "WEEK": "周测", "UNIT": "单元测试", "MONTH": "月考", "MIDTERM": "期中考试", "END_OF_TERM": "期末考试", "SIMULATION": "模拟考试", "OTHER": "其他" }

export const networkData = {
  // 设置试题类型码
  setQuestionTypeCode: (list) => {
    list.forEach(element => {
      if (element.choiceType) {
        element.choiceTypeCode = questionTypeList[element.choiceType]
      }
    });
    return list
  },
  // 设置考试报告类型码
  setExamTypeDesc: (element) => {
    if (element.type) {
      element.typeDesc = examTypeList[element.type]
    }
    return element
  },
  // 获取试题类型
  getQuestionType: (value) => {
    return Object.keys(questionTypeList).find(key => questionTypeList[key] === value);
  },
  // 获取考试报告类型
  getExamType: (value) => {
    return Object.keys(examTypeList).find(key => examTypeList[key] === value);
  },

}